export function loadNewUserProdcutList() {
  return {
    type: 'LOAD_NEWUSER_PRODUCT_LIST',
  };
}
export function loadNewUserProdcutListCompletion(error, list, topicVo) {
  return {
    type: 'LOAD_NEWUSER_PRODUCT_LIST_COMPLETION',
    error,
    list,
    topicVo,
  };
}
